import * as XLSX from "xlsx";

export const generateExcelFromTable = (rows, columns, activeStatement, companyName) => {
  if (rows.length === 0 || columns.length === 0) {
    return null;
  }

  try {
    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Prepare data array
    const data = [];
    
    // Add all rows exactly as they appear
    rows.forEach((row, rowIndex) => {
      const rowData = {};
      columns.forEach(col => {
        // Get the value from the row
        const value = row[col.id];
        
        // Format numbers with proper formatting
        if (typeof value === 'number') {
          if (col.id !== columns[0].id) { // Not the first column (description)
            // Apply number formatting for financial data
            rowData[col.label] = {
              v: Math.abs(value),
              t: 'n',
              z: value < 0 ? '($#,##0);[Red]($#,##0)' : '#,##0'
            };
            if (value < 0) {
              rowData[col.label].v = -Math.abs(value);
            }
          } else {
            rowData[col.label] = value;
          }
        } else if (value === null || value === undefined) {
          rowData[col.label] = '';
        } else {
          rowData[col.label] = String(value);
        }
      });
      data.push(rowData);
    });
    
    // Create worksheet with proper formatting
    const ws = XLSX.utils.json_to_sheet(data, {
      header: columns.map(col => col.label),
      skipHeader: false
    });
    
    // Set column widths
    const colWidths = columns.map(col => ({
      wch: Math.max(col.label.length, 15) // Minimum width 15
    }));
    ws['!cols'] = colWidths;
    
    // Set row heights
    const rowHeights = rows.map(() => ({ hpx: 20 }));
    ws['!rows'] = rowHeights;
    
    // Add bold formatting for header row and important rows
    if (ws['!ref']) {
      const range = XLSX.utils.decode_range(ws['!ref']);
      
      // Bold header row
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!ws[cellAddress]) continue;
        
        ws[cellAddress].s = {
          font: { bold: true, sz: 11 },
          fill: { fgColor: { rgb: "E6E6E6" } }
        };
      }
      
      // Bold company name and statement type rows
      if (rows.length > 0) {
        const firstRowCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
        if (ws[firstRowCell]) {
          ws[firstRowCell].s = { font: { bold: true, sz: 12 } };
        }
        
        if (rows.length > 1) {
          const secondRowCell = XLSX.utils.encode_cell({ r: 1, c: 0 });
          if (ws[secondRowCell]) {
            ws[secondRowCell].s = { font: { bold: true, sz: 11 } };
          }
        }
      }
    }
    
    // Add to workbook
    const sheetName = activeStatement.substring(0, 31); // Excel max 31 chars
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    
    return wb;
  } catch (error) {
    console.error('Error generating Excel:', error);
    return null;
  }
};